import { Injectable } from '@angular/core';
import { ModelFactory } from '../models/model-factory';
import { SessionModel } from '../models/session-model';
import { storage } from '../utils/catalog';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ObjectService {
  constructor(private storageService: StorageService) {}

  private compareObjects(a: SessionModel, b: SessionModel): boolean {
    return a && b && a.cloudId === b.cloudId && a.username === b.username;
  }

  getObjectScope(object: SessionModel): string {
    return `${object.username}.${object.cloudId}`;
  }

  setActiveObject(object: SessionModel): void {
    this.storageService.put(storage.keys.auth, object);
  }

  getActiveObject(): SessionModel {
    return ModelFactory.newInstance(SessionModel, this.storageService.get(storage.keys.auth, {}));
  }

  getObjects(): Array<SessionModel> {
    return ModelFactory.newInstances(SessionModel, this.storageService.get(storage.keys.objects, []));
  }

  addObject(object: SessionModel): boolean {
    const objects = this.getObjects();
    if (objects.find((o) => this.compareObjects(object, o))) return false; // do not add objects with same cloudId
    objects.push(object);
    this.storageService.put(storage.keys.objects, objects);
    return true;
  }

  updateObject(object: SessionModel): void {
    const objects = this.getObjects();
    this.storageService.put(
      storage.keys.objects,
      objects.map((o) => {
        if (this.compareObjects(object, o)) {
          return {
            ...o,
            ...object,
          };
        }
        return o;
      })
    );

    const activeObject = this.getActiveObject();
    if (this.compareObjects(object, activeObject)) {
      this.storageService.put(storage.keys.auth, {
        ...activeObject,
        ...object,
      });
    }
  }

  removeObject(object: SessionModel): void {
    const objects = this.getObjects();
    this.storageService.put(
      storage.keys.objects,
      objects.filter((o) => !this.compareObjects(object, o))
    );
  }
}
